export const POSITION_MAPPER = {
    right: 'row',
    bottom: 'column',
} as const;
